import { updateUserMetaWithDispatch } from "@actions/tsMain";

import { useAppDispatch, useAppSelector } from "~/src/store";
import type { UserMetadata } from "~/src/types";

export const useProductTour = (metadataKey: keyof UserMetadata) => {
  const dispatch = useAppDispatch();
  const userState = useAppSelector((state) => state.main.user);
  // @ts-expect-error - UserMetadata is currently typed as Record<string, any>, so we need to assert the type here
  const hasSeenTour = !!userState.metadata[metadataKey];

  const markTourSeen = () => {
    // @ts-expect-error - UserMetadata is currently typed as Record<string, any>, so we need to assert the type here
    if (!userState.metadata[metadataKey]) {
      updateUserMetaWithDispatch(userState, dispatch, metadataKey, true);
    }
  };

  return { hasSeenTour, markTourSeen };
};
